import React from 'react'
import {useNavigate} from 'react-router-dom'
import {
  residentPortalApi,
  useGetPaymentMethodsQuery,
  useGetPaymentSessionQuery
} from '../../services/residentPortalApi'
import {useAppDispatch} from '../../store/hooks'
import AlertMessage from '../common/AlertMessage'
import Loader from '../common/Loader'
import AdyenPaymentForm from '../common/AdyenPaymentForm'
import {useAccountContext} from '../layout/AccountLayout'
import {getNavigationPaths} from '../../services/navigation'
import Breadcrumbs from '../navigation/Breadcrumbs'
import toast from 'react-hot-toast'
import {getLogger} from '../../services/logging'
import TermsAndConditions from '../common/TermsAndConditions'
import {PaymentOrigin, PaymentType} from '../../types/app-types'

const logger = getLogger('AddPaymentAccountPage')

// TODO: doublecheck settings
const AddPaymentAccountPage = () => {
  const {accountId, reservation} = useAccountContext()
  const navigate = useNavigate()
  const paths = getNavigationPaths(accountId)
  const dispatch = useAppDispatch()
  const paymentSessionQuery = useGetPaymentSessionQuery({
    amountInCents: 0,
    reservationId: reservation.id,
    propertyId: reservation.property.id,
    paymentAccount: true,
    paymentOrigin: PaymentOrigin.ResidentPortal,
    paymentType: PaymentType.PreAuthorization,
    returnUrl: `${window.location.origin}/#${paths.PaymentAccounts}?refresh=true`
  })

  const paymentMethodsQuery = useGetPaymentMethodsQuery(reservation.property.id)

  console.log(`paymentMethodsQuery`, paymentMethodsQuery)

  let paymentContent = null
  if (paymentSessionQuery.isLoading || paymentMethodsQuery.isLoading) {
    paymentContent = <Loader />
  } else if (paymentSessionQuery.data && paymentMethodsQuery.data) {
    const paymentSession = paymentSessionQuery.data
    const paymentMethods = paymentMethodsQuery.data
    paymentContent = (
      <AdyenPaymentForm
        paymentMethods={paymentMethods}
        paymentSession={paymentSession}
        isSavedPayment={true}
        onPaymentCompleted={(result: any) => {
          logger.logInfo('Created payment account', {
            reservationId: reservation.id,
            paymentSession
          })
          toast.success('Payment account saved')
          setTimeout(() => {
            // invalidate cache and navigate back to payment account page after delay
            dispatch(residentPortalApi.util.invalidateTags(['PaymentAccount']))
            navigate(`${paths.PaymentAccounts}?refresh=true`)
          }, 3000)
        }}
      />
    )
  } else {
    const message =
      'Unable to process payments at this time.  If problem persists, please contact support: hello@placemakr.com'
    paymentContent = <AlertMessage type="error" message={message} />
  }

  return (
    <section>
      <Breadcrumbs
        items={[
          {label: 'Account', path: paths.Account, active: false},
          {
            label: 'Payment Accounts',
            path: paths.PaymentAccounts,
            active: false
          },
          {label: 'Add Payment Account', active: true}
        ]}
      />
      <div className="card-default w-full mx-auto">
        <div className="card-body-default">
          <h1 className="card-header">Add Payment Account</h1>
          <div className="mt-4">{paymentContent}</div>
          <div className="mt-4 border border-solid p-4 md:p-8">
            <h2 className="text-lg mb-4">Terms and Conditions</h2>
            <TermsAndConditions />
          </div>
        </div>
      </div>
    </section>
  )
}

export default AddPaymentAccountPage
